<script>
export const group = 'Full'
</script>

<script setup>
import VideoPlayer from '../../VideoPlayer.vue'
import { computed } from 'vue'

const { item } = defineProps({
  item: Object,
})

const emit = defineEmits(['loaded'])

const programMedia = computed(() => item.enrichment.programMedia)
</script>

<template>
  <img v-if="programMedia.type === 'image'" :src="programMedia.url" class="size-full object-cover" @load="emit('loaded')" />
  <VideoPlayer v-if="programMedia.type === 'video'" :src="programMedia.url" :loop="item.properties.loop" class="size-full object-cover" autoplay muted @play="emit('loaded')" />
</template>
